import { ComponentPropsWithoutRef, FC } from 'react';

type FirstIconProps = ComponentPropsWithoutRef<'svg'>;

export const FirstIcon: FC<FirstIconProps> = ({ color, ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            {...props}
        >
            <path
                d="M4.30931 11.6907V4.29248H5.30848V11.6907H4.30931ZM11.9495 11.5937L8.35579 8L11.9495 4.40627L12.6731 5.11298L9.78604 8L12.6731 10.887L11.9495 11.5937Z"
                fill={color || 'currentColor'}
            />
        </svg>
    );
};
